import BigNumber from 'bignumber.js';
import DuckEntity from './DuckEntity';
import DuckEntityForm from './DuckEntityForm';
import FilteredContactList from './FilteredContactList';

const reverseSign = (amount) => new BigNumber(amount).neg().toFixed(2);

const fixSign = (type, amount) => {
  // Invert the sign for credits and payments
  return amount && (type === 'credit' || type === 'payment')
    ? reverseSign(amount)
    : amount;
};

const transformFromServer = (model) => {
  const { billing_item_amounts: amounts = [], type } = model;

  return {
    ...model,
    amount: fixSign(type, model.amount),
    billing_item_amounts: amounts.map(a => ({
      ...a,
      // Adds in computed `id` value for billing item amounts
      id: a.id || `amount-${Math.random()}`,
      amount: fixSign(type, a.amount)
    }))
  };
};

const transformToServer = (model) => {
  const { billing_item_amounts: amounts = [], type } = model;

  return {
    ...model,
    billing_item_amounts: amounts.map(a => {
      return { ...a, amount: fixSign(type, a.amount) };
    })
  };
};

const copyAmounts = (amounts, reverseAmounts) => {
  return amounts.map(a => ({
    ...a,
    id: `amount-${Math.random()}`,
    billing_category_id: a.billing_category.id, // Need to do this for contract charges.
    amount: reverseAmounts ? reverseSign(a.amount) : a.amount
  }));
}

const billingItems = new FilteredContactList(new DuckEntity('billingItems'));
const autopayInstallments = new FilteredContactList(new DuckEntity('autopayInstallments'));

const billingItemForm = new DuckEntityForm('billingItemForm', billingItems, {
  initialState: { billing_item_amounts: [{}] },

  transformLoad: transformFromServer,

  transformSave: transformToServer
});

/**
 * Loads a charge opposite to the given charge billing item
 *
 * @param charge the charge to create an opposite for
 */
billingItemForm.actions.loadOpposite = (charge) => {
  return billingItemForm.actions.load({
    type: 'charge',
    billing_account_id: charge.billing_account_id,
    billing_item_amounts: copyAmounts(charge.billing_item_amounts, true),
    billing_date: charge.billing_date,
    description: `Reverse ${charge.description}`,
    recognized_date: charge.recognized_date
  });
};

/**
 * Loads a billing item equivalent to a given billing item, but with only properties that are safe to copy
 *
 * @param item the billing item to create an opposite for
 */
billingItemForm.actions.loadCopy = (item) => {
  return billingItemForm.actions.load({
    type: item.type,
    billing_account_id: item.billing_account_id,
    billing_item_amounts: copyAmounts(item.billing_item_amounts, false),
    billing_date: item.billing_date,
    description: item.description,
    recognized_date: item.recognized_date,
    received_date: item.received_date,
    payment_method: item.payment_method
  });
};

billingItemForm.actions.transformFromServer = transformFromServer;

billingItemForm.actions.transformToServer = transformToServer;

export { billingItems, autopayInstallments, billingItemForm };
